// import books from '../assets/svg/header/books.svg';
import i18next from 'i18next';
import dashboard from '../assets/svg/header/dashboard.svg?react';
import transactions from '../assets/svg/header/transactions.svg?react';
import knowledgeBase from '../assets/svg/header/knowledge-base.svg?react';
import storageIcon from '../assets/svg/header/storage.svg?react';
// import faq from '../assets/svg/header/faq.svg';
// import phone from '../assets/svg/header/phone.svg';
// import users from '../assets/svg/header/users.svg';

export const headerBarList = () => {
  const t = i18next.t;
  return [
    { id: 0, Icon: dashboard, path: '/dashboard', text: t('Dashboard') },
    { id: 1, Icon: transactions, path: '/transactions', text: t('orders') },
    {
      id: 2,
      Icon: knowledgeBase,
      path: '/knowledge-base',
      text: t('knowledge_base'),
    },
    {
      id: 3,
      Icon: storageIcon,
      path: '/documents',
      text: t('storage'),
    },
    // { id: 1, src: users, path: '/user', text: 'Сотрудники' },
    // { id: 2, src: books, path: '#', text: 'Справочники' },
    // { id: 3, src: faq, path: '#', text: 'FAQ' },
    // { id: 4, src: phone, path: '#', text: 'Контакты' },
  ];
};
